import { ReactNode } from 'react';

const Section = (props: { children?: ReactNode; className?: string }) => (
  <section className={props.className ? props.className : 'py-8'}>
    {props.children}
  </section>
);

export default Section;
